import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAntdesignComponent } from './simple-icons-antdesign.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAntdesignComponent ],
    exports:      [ SimpleIconsAntdesignComponent ],
    bootstrap:    []
})
export class SimpleIconsAntdesignModule {}
